import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../configure_store'

const _getState = (state: RootState) => state.companies

export const getRepairersSelector = createSelector(
  _getState,
  (state) => state.repairers
)

export const getRegion = createSelector(
  _getState,
  (state) => state.region
)
